import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { combineReducers } from "redux";

import main from "reducers/main";

const initialState = {};
const enhancers = [];
const middleware = [thunk];

const rootReducer = combineReducers({ main });

// if (process.env.NODE_ENV === "development") {
//   const devToolsExtension =
//     window.__REDUX_DEVTOOLS_EXTENSION__ &&
//     window.__REDUX_DEVTOOLS_EXTENSION__();
//   enhancers.push(devToolsExtension);
// }

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(rootReducer, initialState, composedEnhancers);

export default store;



// WEBPACK FOOTER //
// ./src/store.js